export const SkeletonPhotoBorderedIcon = ({ ...rest }) => (
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18" {...rest}>
    <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
  </svg>
);
export const SkeletonPhotoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="33" fill="none" viewBox="0 0 45 33">
    <path
      fill="#F3F4F6"
      fillRule="evenodd"
      d="M33.3 8.66c2.025 0 3.666-1.719 3.666-3.838 0-2.12-1.641-3.838-3.665-3.838s-3.665 1.718-3.665 3.838S31.276 8.66 33.3 8.66zM23.158 31.9H1.002a1 1 0 01-.858-1.514L15.26 5.187a.997.997 0 011.697-.027c1.958 3.08 6.883 10.842 11.073 17.537l4.544-7.62a.966.966 0 011.64-.04l10.463 15.28c.458.67.012 1.587-.777 1.596l-10.153.103-10.59-.116z"
      clipRule="evenodd"
    />
  </svg>
);
